import React from 'react';
import './ui.css';

const Select = ({
  label,
  subLabel,
  error,
  className = '',
  wrapClassName = '',
  children,
  ...selectProps
}) => {
  const selectClasses = ['pn-select', error ? 'pn-select--error' : '', className]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={`pn-field ${wrapClassName}`.trim()}>
      {label ? <label className="pn-label">{label}</label> : null}
      {subLabel ? <p className="pn-sublabel">{subLabel}</p> : null}
      <select className={selectClasses} {...selectProps}>
        {children}
      </select>
      {error ? <p className="pn-field-error">{error}</p> : null}
    </div>
  );
};

export default Select;
